
export default function Products() {
  return (
    <section id="products" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex justify-between items-start mb-20">
          <div className="max-w-xl">
            <p className="text-xs uppercase tracking-widest text-gray-500 mb-4">
              Our Products
            </p>
            <h2 className="text-6xl font-bold text-gray-900">
              VPN & Cleaner Solutions
            </h2>
          </div>
          <p className="text-base text-gray-600 max-w-sm leading-relaxed mt-8">
            Designed to enhance user experience and improve the security of mobile devices
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div className="relative rounded-3xl overflow-hidden h-[640px] bg-gradient-to-br from-blue-950 via-purple-950 to-indigo-950 p-16">
            <div className="relative z-10">
              <div className="w-12 h-12 flex items-center justify-center mb-10">
                <i className="ri-shield-check-line text-5xl text-white"></i>
              </div>
              <h3 className="text-4xl font-bold text-white mb-16">
                VPN Protection
              </h3>
              <ul className="space-y-8 text-white/80 text-base">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-white/60 mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span>Military-grade encryption</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-white/60 mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span>Global server network</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-white/60 mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span>Zero-log policy</span>
                </li>
              </ul>
            </div>
            <div className="absolute bottom-8 right-8 text-[120px] font-bold text-white/10 leading-none">
              01
            </div>
          </div>

          <div className="relative rounded-3xl overflow-hidden h-[520px] bg-white shadow-xl p-16 border border-gray-100">
            <div className="relative z-10">
              <div className="w-12 h-12 flex items-center justify-center mb-10">
                <i className="ri-brush-line text-5xl bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"></i>
              </div>
              <h3 className="text-4xl font-bold text-gray-900 mb-16">
                System Cleaner
              </h3>
              <ul className="space-y-8 text-gray-700 text-base">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-gray-400 mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span>Intelligent cache management</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-gray-400 mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span>Storage optimization</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-gray-400 mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span>Performance boost</span>
                </li>
              </ul>
            </div>
            <div className="absolute bottom-8 right-8 text-[120px] font-bold text-gray-900/5 leading-none">
              02
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}